import React from "react";
import { useRouteMatch } from "react-router";
import { Route, Switch } from "react-router-dom";
import OrganizationOrderPurchaseCorrectionEditPage from "./Edit";
import OrganizationOrderPurchaseCorrectionNewPage from "./New";

const OrganizationOrderPurchaseCorrectionPage = () => {
	const match = useRouteMatch();

	return (
		<Switch>
			<Route path={`${match.url}/new`} exact component={OrganizationOrderPurchaseCorrectionNewPage} />
			<Route path={`${match.url}/:correctionId`} exact component={OrganizationOrderPurchaseCorrectionEditPage} />
		</Switch>
	);
};

export default OrganizationOrderPurchaseCorrectionPage;
